import { render, staticRenderFns } from "./add-edit-webhook-modal.vue?vue&type=template&id=cd61f978&scoped=true"
import script from "./add-edit-webhook-modal.vue?vue&type=script&lang=js"
export * from "./add-edit-webhook-modal.vue?vue&type=script&lang=js"
import style0 from "./add-edit-webhook-modal.vue?vue&type=style&index=0&id=cd61f978&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd61f978",
  null
  
)

export default component.exports